"use clent";

import React from "react";
import "./styles.css";
import "../common.css";

export const AboutBlock = ({
  backgroundColor = "#ffffff",
  borderRadius = 0,
  textColor = "#242323",
}) => {
  return (
    <div
      className="feature__wrapper"
      style={{
        background: backgroundColor,
        borderRadius: borderRadius,
        marginTop: borderRadius ? borderRadius * -1 : 0,
        marginBottom: borderRadius ? borderRadius * -1 : 0,
        position: borderRadius ? "relative" : "static",
        color: textColor,
      }}
    >
      <div className="container">
        <h2 className="about__title">
          О проекте
          <img src="/img/sharx-logo.svg" alt="" />
        </h2>

        <div className="about__grid">
          <div className="about__column about__column--left">
            <div className="about__info">
              <div className="about__subtitle">Бренд</div>
              <div>ООО «Шаркс ДЦ»</div>
            </div>

            <div className="about__info">
              <div className="about__subtitle">Индустрия</div>
              <div>IT, разработка ПО</div>
            </div>

            <div className="about__info">
              <div className="about__subtitle">Релиз</div>
              <div>2023</div>
            </div>

            <div className="about__info">
              <div className="about__subtitle">Cсылка</div>
              <div>
                <a href="https://sharxdc.ru" target="_blank" rel="noreferrer">
                  https://sharxdc.ru
                </a>
              </div>
            </div>
          </div>
          <div className="about__column">
            <div className="about__info">
              <div className="about__subtitle">О проекте</div>
              <div>
                Sharx DataCenter — крупная российская компания, которая создает
                технологии для виртуализации и объединения ИТ-систем. Для их
                экосистемы продуктов потребовался единый визуальный стиль и
                стандартизированный набор правил, чтобы интерфейсы были
                удобными, понятными и выглядели согласованно.
              </div>
            </div>

            <div className="about__info">
              <div className="about__subtitle">Задача</div>
              <div>
                Создать уникальную дизайн-систему, которая объединит все
                продукты Sharx DataCenter в едином стиле. Это поможет сделать
                пользовательский опыт удобным и интуитивно понятным, исключив
                необходимость привыкать к разным интерфейсам при переходе между
                продуктами.
              </div>
            </div>

            <div className="about__info">
              <div className="about__subtitle">Решение</div>
              <div>
                Мы разработали для Sharx DataCenter дизайн-систему, которая
                связала все продукты компании единым стилем и подходом. Система
                включает стандарты и библиотеку компонентов, упрощающих создание
                интерфейсов. Благодаря этому собрать несколько версий одной
                страницы теперь можно менее чем за час, а проработать сложный
                сценарий — за 2–3 часа. Ранее на такие задачи уходило бы
                несколько дней.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
